import script from "./PromptFlowsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./PromptFlowsList.vue?vue&type=script&lang=ts&setup=true"

import "./PromptFlowsList.vue?vue&type=style&index=0&id=69bca42c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69bca42c"]])

export default __exports__